import { CustomAffichage, ProprieteAffichee, TypePropriete } from "./proprieteAffichee";
import { Site } from "./site";
import { WorkflowEtapeModele } from "./workflowEtapeModele";

export class WorkflowModele {
  workflowModeleId: number;
  nom: string;
  siteId: number;
  regionId: number;
  workflowModeleParentId: number;
  site: Site;
  //region: Region;
  regionNom: string;
  workflowModeleParent: WorkflowModele;
  dateDerniereModification: Date;
  workflowEtapeModeles: WorkflowEtapeModele[];
  nomDate: string;

  getProprietesAffichees() {
    let tab: ProprieteAffichee[] = [];
    tab.push(new ProprieteAffichee('nom', 'GLOBAL.NOM'));
    tab.push(new ProprieteAffichee('dateDerniereModification', 'GLOBAL.DATE_MODIFICATION', '', new CustomAffichage(TypePropriete.Date)));
    return tab;
  }

}
